export default __webpack_public_path__ + "static/media/image3.7491ff37.svg";